// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    overflow: visible !important;
}

.icon-arrow::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.title {
    cursor: pointer;
    font-size: 20px;
    font-weight: 400;
    margin: 0;
    color: #6E7079;
}

    .title:hover {
        color: #000;
    }

.navigation {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 20px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1000;
}

.navigation-content {
    display: flex;
    align-items: flex-start;
    gap: 20px;
}

.menu-container {
    margin-top: -4px;
}
`, "",{"version":3,"sources":["webpack://./src/controls/chartcolumn/chartcolumn.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;;AAEA;IACI,gDAAkC;AACtC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;IAEI;QACI,WAAW;IACf;;AAEJ;IACI,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[":host {\r\n    overflow: visible !important;\r\n}\r\n\r\n.icon-arrow::before {\r\n    content: url('./assets/arrow.svg');\r\n}\r\n\r\n.title {\r\n    cursor: pointer;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n    margin: 0;\r\n    color: #6E7079;\r\n}\r\n\r\n    .title:hover {\r\n        color: #000;\r\n    }\r\n\r\n.navigation {\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    padding: 20px;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    z-index: 1000;\r\n}\r\n\r\n.navigation-content {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 20px;\r\n}\r\n\r\n.menu-container {\r\n    margin-top: -4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
